<template>
      <div class="lezhi-project2">
        <headerBlack-view></headerBlack-view>
        <div class="wrapper ">
            <div class="introduce_wrap flex-layout main">
                <div class="introduce_left">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">项目介绍</h2>
                            <img src="@/assets/yunqiao/introduce.png" />
                        </div>
                    </div>
                    <div class="introduce_name">STEAM课程</div>
                    <div class="introduce_detail">
                      STEAM课程给宁夏中小学教师和中小学生提供计算思维培养课程《少年AI教程：Kodu编程案例详解》，
                      教师通过学习在提升自身科学素养的同时可以指导学生、引导学生。计算思维不仅在计算机领域有者作用，
                      更能辅助学生在面对问题、解决问题时的心理状态的调整。
                    </div>
                </div>
                <div class="introduce_right flex-layout ">
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/stem/01.png" />
                        <h3>科学素养</h3>
                        <span>Scientific</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/stem/02.png" />
                        <h3>计算思维</h3>
                        <span>Computational </span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/stem/03.png" />
                        <h3>综合提升</h3>
                        <span>Comprehensive</span>
                    </div>
                </div>
            </div>    
            <div class="features-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">产品特点</h2>
                            <img src="@/assets/yunqiao/feature.png" />
                        </div>
                    </div>
                    <div class="container flex-layout">
                        <div class="item flex-align">
                            <div class="wrap">
                                <h3>课程资源输出</h3>
                                <p>优质的steam思维模式课程资源</p>
                            </div>
                        </div>
                        <div class="item"></div>
                        <div class="item flex-align">
                             <div class="wrap">
                                <h3>专家团队</h3>
                                <p>计算思维提出者周以真教授讲师</p>
                            </div>
                        </div>
                        <div class="item "></div>
                        <div class="item flex-align">
                            <div class="wrap">
                                <h3>计算思维建立</h3>
                                <p>以计算机变成为主导课程引导学生思考问题方式改变</p>
                            </div>
                        </div>
                        <div class="item"></div>
                    </div>
                </div>
            </div>
            <div class="architecture-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu_white.png" />
                        <div class="">
                            <h2 class="f28" style="color:#fff">架构形式</h2>
                            <img src="@/assets/yunqiao/architecture.png" />
                        </div>
                    </div>
                    <div class="container flex-layout">
                        <div class="left-article">
                            <div class="section section-one flex-layout">
                                <h2>01</h2>
                            </div>
                            <div class="section section-two flex-layout">
                                <div class="describe tr">
                                    <h3>目标</h3>
                                    <p class="tl">通过教师学习提升科学素养的同时指导学生学习，促使学生以师为表、
                                        以师为镜增强学习热情，激发学生想象创造能力、团队合作意识和表述感染力</p>
                                </div>
                            </div>
                             <div class="section section-three flex-layout">
                                <h2>03</h2>
                            </div>
                             <div class="section section-four flex-layout">
                                <div class="describe tr">
                                    <h3>学生  教师</h3>
                                    <p class="tl">教师、学生通过学习课程提升自身的科技素养，建立新的思考模式，
                                        基于计算思维分析，从而使学习者在面对问题时思维更加清晰。</p>
                                </div>
                            </div>
                        </div>
                        <div class="line flex-column">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                        <div class="right-article flex-column">
                            <div class="section section-one flex-layout">
                                <div class="describe">
                                    <h3>核心</h3>
                                    <p>steam课程以全面提升师生综合能力为核心，围绕计算机思维、科学素养提升为基础，激发想象与创造等能力。</p>
                                </div>
                            </div>
                            <div class="section section-two flex-layout">
                                <h2>02</h2>
                            </div>
                            <div class="section section-three flex-layout">
                                <div class="describe">
                                    <h3>课程输出</h3>
                                    <p>“中小学生计算思维培养课程”由计算思维提出者周以真教授团队所开发的可视化编程语言。
                            </p>
                                </div>
                            </div>
                            <div class="section section-four flex-layout">
                                <h2>04</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="win-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">合作共赢</h2>
                            <img src="@/assets/yunqiao/win2.png" />
                        </div>
                    </div>
                    <div class="container flex-align-between">
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/stem/10.png" />
                            <span>Expert Team</span>
                            <span>专家团队</span>
                        </div>
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/stem/11.png" />
                            <span>Resource Output </span>
                            <span>资源输出</span>
                        </div>
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/stem/12.png" />
                            <span>Teachers Improve</span>
                            <span>教师提升</span>
                        </div>
                        <div class="item flex-column">
                            <img src="@/assets/yunqiao/stem/13.png" />
                            <span>Students Improve</span>
                            <span>学生提升</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
    @import "./less/lezhi_common.less";
    @import "./less/lezhi_project2.less";
</style>